import { render } from "./HeroGlobal.vue?vue&type=template&id=b1156412"
import script from "./HeroGlobal.vue?vue&type=script&lang=js"
export * from "./HeroGlobal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__